import React from "react";
import { Modal } from "react-bootstrap";
import logoImage from "../../images/people-whatzon.svg";
import blackLogo from "../../images/whatzon-black.svg";
import { UPDATE_TERMS_AND_CONDITION_FLAG } from "../../mutation/updateTermsAndConditionFlag";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";

const TermsAndConditionPopup = (props) => {
  const [updateTermsAndConditionFlag] = useMutation(
    UPDATE_TERMS_AND_CONDITION_FLAG,
    {
      client: hasuraClient,
    }
  );
  const userRole = localStorage.getItem("user_profile_role") || "";
  const history = useHistory();
  return (
    <Modal
      {...props}
      className="tAndC-popup"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="left-side-t-and-c">
          <div className="wlcm-class mb-3">Welcome to WhatzOn!</div>
          <div className="desc-heading mb-3">
            Congratulations on choosing to list your Council on the Whatzon App.
          </div>
          <div className="desc-text mb-3">
            We are an all-Australian owned company that has three founders based
            in country Victoria. With a background in both business and the club
            industry, we have built this application specifically for Not for
            Profits, Businesses and Councils right across Australia.
          </div>
          <div className="desc-text mb-3">
            Registered Clubs will be encouraging their members to download the
            application to keep up to date with Events and Deals in their area.
            With over 13 million Club Members across Australia: you have a large
            audience to market to, so please make the most of your free listing.
          </div>
          <div className="desc-text mb-3">
            The application is funded through a small annual subscription paid
            for <span className="desc-heading">by users</span> of the app,{" "}
            <span className="desc-heading text-decoration-underline">
              not you
            </span>{" "}
            <span className="desc-heading">
              the Council or Business owners.
            </span>
          </div>
          <div className="desc-heading mb-3">
            So Yes it is completely free for Councils and Businesses to use.
          </div>
          <div className="desc-text">
            The only conditions of use are as follows:
          </div>
          <ul className="desc-text mb-3">
            <li>
              We ask that you regularly update the Councils profile with
              information that is relevant to visitors to your region, residents
              and business owners.
            </li>
            <li>
              It’s a great way to communicate with rate payers, business owners
              and visitors, as those coming from outside your region will have
              already downloaded the application to use in their own towns.
            </li>
            <li>
              The GEO fencing technology ensures that relevant information to
              your location is always at a users finger tips.
            </li>
          </ul>
          <div className="desc-text mb-3">
            That’s It. It’s great to have you on onboard. Instructional videos
            are available on our website www.whatzon.com.au should you need to
            know more.
          </div>
          <div className="desc-text mb-3">
            Should you have any questions please do not hesitate to contact us
            on the following email address: steve@whatzon.net.au.
          </div>
          <div className="desc-text mb-3">
            Please also put forward any suggestions on how we may improve.
          </div>
          <div className="desc-text">Regards</div>
          <div className="desc-text">The Team at Whatzon</div>
          <div className="button-row">
            <div
              onClick={() => {
                updateTermsAndConditionFlag({
                  variables: {
                    user_id: localStorage.getItem("user_id") || "",
                    term_and_conditions: true,
                  },
                })
                  .then(async (response) => {
                    if (
                      response?.data?.update_users?.returning[0]
                        .term_and_conditions
                    ) {
                      localStorage.removeItem("user_profile_role");
                      localStorage.removeItem("term_and_conditions");
                      props.setIsTandCModalOpen(false);
                      props.setNewModalOpen(true);
                      localStorage.setItem("isnewuser", true);
                    } else {
                      history.push("/dashboard");
                    }
                  })
                  .catch((e) => {
                    const errors = e.graphQLErrors;
                    console.log("errors", errors);
                    props.setIsTandCModalOpen(false);
                    history.push("/login");
                  });
              }}
              className="button"
              style={{ cursor: "pointer" }}
            >
              I Acknowledge
            </div>
          </div>
        </div>
        <div className="bg-div-right-container">
          <div className="bg-image-right">
            <div className="bg-internal-container">
              <img className="" src={logoImage} alt="logoImage" />
              <img className="" src={blackLogo} alt="blackLogo" />
              <p className="bg-text-dec">
                Connect to new customers & grow your business
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TermsAndConditionPopup;
